
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "../../common/common-interface";
import { State } from "vuex-class";
import sha256 from "js-sha256";
import { getMerchantInfo, getOperBacklog } from "@/api/api-operation-service";
import { resetSelfPwd } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component
export default class PiHeader extends Vue {
  @Prop({ default: "" }) private menuId!: string;
  @Prop({ default: false }) private isLogin!: boolean;
  @State("sys") sys!: objAny;

  private merchentInfo: objAny = {
    fullName: ""
  };
  private msgNum = 0;
  private visible = false;
  private modal = false;
  private msgTipsList: objAny[] = [
    {
      key: "mchDivideSettlementAmount",
      name: i18n.t("header.order"),
      url: "/revenue-settlement/share-settlement?orderStatus=1"
    }
  ];

  private changeLangList: objAny[] = [
    {
      value: process.env.VUE_APP_LANG,
      label: process.env.VUE_APP_LANG_NAME
    },
    {
      value: "en-US",
      label: "English"
    }
  ];
  public changeLangFn(val: string): void {
    localStorage.setItem("language", val);
    this.$i18n.locale = val;
    window.location.reload();
  }
  public goOut(): void {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("header.order") + "",
      onOk: () => {
        this.sysLoginOut();
        // this.$Message.info("Clicked ok");
      },
      onCancel: () => {
        // this.$Message.info("Clicked cancel");
      }
    });
  }
  async sysLoginOut(): Promise<void> {
    // await sysLoginOut({});
    this.$common.out();
  }
  public privilegeVoList(privilegeVoList: object[]): boolean {
    let isUrl = false;
    privilegeVoList.map((child: objAny) => {
      if (child.privilegeCode == "100501" && child.checked) {
        isUrl = true;
      }
    });
    return isUrl;
  }
  public navClick(item: objAny): void {
    if (item.children && item.children.length > 0) {
      let url = "";
      item.children.map((itemData: objAny) => {
        if (itemData.children && item.children.length > 0 && url == "") {
          itemData.children.map((itemDataChild: objAny) => {
            const list = itemDataChild.privilegeVoList || [];
            if (this.privilegeVoList(list) && url == "") {
              url = itemDataChild.url;
            }
          });
        } else if (url == "") {
          const list = itemData.privilegeVoList || [];
          if (this.privilegeVoList(list)) {
            url = itemData.url;
          }
        }
      });
      if (this["$route"].path != url) {
        this.$router.push(url);
      }
    } else {
      this["$router"].push(item.url);
    }
  }

  public goHome() {
    const url = this["$route"].path;
    if (url != "/home") {
      this["$router"].push("/home");
    }
  }
  async getMerchantInfo() {
    const ret = await getMerchantInfo({
      merchantPkId: this.sys.userInfo.merchantPkId
    });
    if (ret.status == this["$config"].apiStatus) {
      const data = ret.data[0];
      this.merchentInfo.fullName = data.fullName;
      document.title = "【" + data.fullName + "】" + i18n.t("sysTitle");
    }
  }
  async getOperBacklog() {
    const ret = await getOperBacklog({});
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data[0];
      this.msgNum = data.totalAmount || 0;
      for (const i in data) {
        this.msgTipsList.map((item: objAny) => {
          if (i == item.key) {
            item.value = data[i];
          }
        });
      }
    }
  }

  private formInlinePassw = {
    currentPassword: "",
    userPkId: "",
    userPwd: "",
    confirmPassword: ""
  };
  private ruleInlinePassw = {
    currentPassword: [
      {
        required: true,
        trigger: "blur",
        message: i18n.t("regular.please")
      }
    ],
    userPwd: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          const reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!#$%&])[A-Za-z\d!#$%&]{12,18}$/;
          if (!value) {
            return new Error(i18n.t("regular.please") + "");
          } else if (value.length < 12 || value.length > 18) {
            return new Error(i18n.t("regular.passwordTips1") + "");
          } else if (!reg.test(value)) {
            return new Error(i18n.t("regular.passwordTips2") + "");
          }
          return true;
        }
      }
    ],
    confirmPassword: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          const reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!#$%&])[A-Za-z\d!#$%&]{12,18}$/;
          if (!value) {
            return new Error(i18n.t("regular.please") + "");
          } else if (value.length < 12 || value.length > 18) {
            return new Error(i18n.t("regular.passwordTips1") + "");
          } else if (!reg.test(value)) {
            return new Error(i18n.t("regular.passwordTips2") + "");
          } else if (value != this.formInlinePassw.userPwd) {
            return new Error(
              i18n.t("upSafePassword.confirmPasswordError") + ""
            );
          }
          return true;
        }
      }
    ]
  };

  private isShowChangePass = false;
  public handelChangePass() {
    this.$refs.formInlinePassw.resetFields();
    this.isShowChangePass = true;
  }
  async handChangePassSubmit() {
    await this.$refs["formInlinePassw"].validate(async (valid: boolean) => {
      if (valid) {
        const params = {
          currentPassword: sha256.sha256(this.formInlinePassw.currentPassword),
          userPwd: sha256.sha256(this.formInlinePassw.userPwd),
          userPkId: this.sys.userInfo.userPkId
        };
        const json: objAny = JSON.parse(JSON.stringify(params));

        const ret = await resetSelfPwd(json);
        if (ret.status === this.$config.apiStatus) {
          this.$Message.success(i18n.t("upSafePassword.upSuccess"));
          setTimeout(() => {
            this["$router"].push("/login");
          }, 500);
        } else {
          this.$Message.error(i18n.t("upSafePassword.upError"));
        }
      }
    });
  }
  mounted(): void {
    if (this.isLogin) {
      this.getOperBacklog();
    }
    if (process.env.VUE_APP_SHOWCHINESE === "1") {
      this.changeLangList.push({
        value: "zh-CN",
        label: "简体中文"
      });
    }
    this.getMerchantInfo();
  }
}
